// @ts-nocheck
import React from 'react';
import PropTypes from 'react-proptypes';
import cx from 'classnames';
import { Record, FormValues } from '@fulcrumapp/fulcrum-core';
import ElementView from './base/element-view';
import RecordLinkElementItemView from './record-link-element-item-view';
import Button from '../../shared/button';
import Modal from '../../shared/modal';
import RecordLinkPicker from './record-link-picker';

export default class RecordLinkElementView extends ElementView {
  static propTypes = {
    ...ElementView.propTypes,
    onRecordSelect: PropTypes.func.isRequired,
    onRecordNew: PropTypes.func.isRequired,
    onRecordOpen: PropTypes.func.isRequired,
    record: PropTypes.instanceOf(Record).isRequired,
    valuesForConditions: PropTypes.instanceOf(FormValues).isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      selectingRecord: false,
    };
  }

  renderViewOnly() {
    return this.renderEditable();
  }

  renderEditable() {
    const { styles } = RecordLinkElementView;

    // TODO (zhm) fix viewOnlyMode below

    const hasButtons = this.showSelectButton || this.showAddButton;

    return (
      <>
        {this.renderFormError()}

        {hasButtons
          && (
            <div className={styles.buttons}>
              {this.renderSelectButton()}
              {this.renderAddButton()}
            </div>
          )}

        <div className={styles.records}>
          {this.renderLinkedRecords()}
        </div>

        <Modal
          show={this.state.selectingRecord}
          onHide={this.handlePickerHide}
        >
          <div className={cx('modal-content', styles.picker)}>
            <RecordLinkPicker
              record={this.props.record}
              value={this.props.value}
              valuesForPredicate={this.props.valuesForConditions}
              viewOnlyMode={false}
              onCloseClick={this.handlePickerHide}
              onRecordClick={this.handleRecordSelect}
            />
          </div>
        </Modal>
      </>
    );
  }

  renderFormError() {
    if (this.props.element.form) {
      return null;
    }

    const { styles } = RecordLinkElementView;

    return (
      <div className={styles.formError}>{'The linked app does not exist or you don\'t have permission to it.'}</div>
    );
  }

  renderSelectButton() {
    if (!this.showSelectButton) {
      return null;
    }

    return (
      <Button
        affirm
        small
        onClick={this.handleSelectClick}
        defaultMargin={false}
      >
        Select
      </Button>
    );
  }

  renderAddButton() {
    if (!this.showAddButton) {
      return null;
    }

    return (
      <Button
        affirm
        small
        onClick={this.handleAddClick}
        defaultMargin={false}
      >
        New
      </Button>
    );
  }

  renderLinkedRecords() {
    return this.props.value.items.map((item, index) => (
      <RecordLinkElementItemView
        key={`${item.id}:${index}`}
        item={item}
        disabled={this.props.disabled}
        editing={this.props.editing}
        onRemoveClick={this.handleItemRemove}
        onClick={this.props.onRecordOpen}
      />
    ));
  }

  handlePickerHide = () => {
    this.setState({ selectingRecord: false });
  };

  handleSelectClick = () => {
    this.setState({ selectingRecord: true });
  };

  handleAddClick = () => {
    this.props.onRecordNew(this.props.value);
  };

  handleRecordSelect = (record) => {
    this.setState({ selectingRecord: false });
    this.props.onRecordSelect(this.props.value, record);
  };

  handleItemRemove = (item) => {
    this.props.value.removeItem(item.id);
    this.props.onChange(this.props.value);
  };

  get canAddMoreItems() {
    if (!this.props.element.allowMultiple && this.props.value.length) {
      return false;
    }
    return true;
  }

  get showSelectButton() {
    return this.props.editing && this.canEdit && this.canAddMoreItems && this.props.element.form && this.props.element.allowExisting;
  }

  get showAddButton() {
    return this.props.editing && this.canEdit && this.canAddMoreItems && this.props.element.form && this.props.element.allowCreating;
  }
}

const styles = cssInJS({
  formError: {
    backgroundColor: '#f2dede',
    border: '1px solid #d9a0a0',
    color: '#000',
    marginTop: 6,
    marginBottom: 6,
    marginRight: 0,
    padding: 6,
    borderRadius: 5,
  },

  buttons: {
    paddingTop: 4,
  },

  picker: {
    position: 'fixed',
    left: '50%',
    top: '50%',
    width: 500,
    height: 420,
    marginLeft: -250,
    marginTop: -200,
    borderRadius: 5,
    overflow: 'hidden',
    boxShadow: '0 14px 45px rgba(0,0,0,0.25), 0 10px 18px rgba(0,0,0,0.22)',
    fontFamily: THEME.fontFamily,
  },
});

RecordLinkElementView.styles = styles;
